export default type => type && type.toLowerCase() === 'arm'
